import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { UnlinkedVeterinaryUser } from '../../domain/models/unlinked-veterinary-user.model';
import { IUnlinkedVeterinaryUsersRepository } from '../../domain/repositories/unlinked-veterinary-users.repository';
import { UnlinkedVeterinaryUsersRemoteDatasource } from '../datasources/remote/unlinked-veterinary-users.remote-datasource';
import { UnlinkedVeterinaryUserMapper } from '../mappers/unlinked-veterinary-user.mapper';

@Injectable()
export class UnlinkedVeterinaryUsersRepositoryImpl implements IUnlinkedVeterinaryUsersRepository {
  private readonly datasource = inject(UnlinkedVeterinaryUsersRemoteDatasource);
  private readonly mapper = inject(UnlinkedVeterinaryUserMapper);

  public list(organizationId: number): Observable<readonly UnlinkedVeterinaryUser[]> {
    return this.datasource.list(organizationId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toModel(dto))),
    );
  }
}
